import Locale from "../../3x1010/Locale";
import MainScene from "./MainScene";
import ProgressBar from "./ProgressBar";
import Tracking from "./Tracking";
import ZoomPanel from "./ZoomPanel";

export default class DetailedStatsPanel extends Phaser.GameObjects.Container {
  constructor(scene, fase, stroke, ct) {
    super(scene);
    this.scene = scene;
    this.fase = fase;
    this.stroke = stroke;
    this.stats = this.fase.stats;
    this.ct = ct;
    this.vlines = [];
    this.currentRadius = ZoomPanel.RADIUS; //- 2;
    this.restrictedRadius = ZoomPanel.RADIUS; //;
    //console.log(this.stroke);
  }

  init() {
    // Crea il titolo
    let posy = 0;
    const title = this.scene.add.text(0, 0, Locale.g(this.fase.label), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_1) });
    title.setOrigin(0, 0);
    this.add(title);
    title.y = ZoomPanel.PADDING / 2;
    title.x = ZoomPanel.PADDING / 2;
    posy += 40;
    this.title = title;

    this.createLines(posy);

    // Aggiunge una x immagine per chiudere nell'angolo
    const close = this.scene.add.image(this.width - 16, 16, "close");
    close.setInteractive({ useHandCursor: true });
    this.add(close);
    close.on("pointerdown", (e) => {
      this.alpha = 0.00001;
      this.scene.time.delayedCall(200, () => {
        this.ct.additionalInfo.destroy();
        this.ct.additionalInfo = null;
      });
    });

    this.setInteractive({ hitArea: new Phaser.Geom.Rectangle(this.width / 2, this.height / 2, this.width, this.height), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: false });

    //this.createBackground();
  }

  createLines(posy) {
    const a = this.stats;
    // Prima calcola il numero di frame start e end
    //let fstart = 10000000000000;
    let fstart = this.fase.frameTime;
    let fend = 0;
    let propNum = 0;
    this.vlines = [];

    for (let prop in a) {
      if (typeof a[prop] !== "string") {
        if (a[prop]) {
          propNum++;
          const el = a[prop];
          if (el.frame_start < fstart) {
            fstart = el.frame_start;
          }
          const calcfend = el.frame_start + el.signed_errors.length;
          if (calcfend > fend) {
            fend = calcfend;
          }
        }
      }
    }

    const tmp = this.stroke.fasi;
    for (let i = 0; i < tmp.length; i++) {
      if (tmp[i].uid === this.fase.uid) {
        if (tmp[i + 1]) {
          fend = tmp[i + 1].frameTime;
        }
      }
    }

    //debugger;

    // Ora crea le linee
    const sorted = [];
    for (let prop in a) {
      if (typeof a[prop] !== "string") {
        if (a[prop]) {
          const meta = Tracking.getMeta(prop, this.stroke.type, this.fase.label);
          sorted.push({ prop: prop, order: meta.order });
        }
      }
    }
    //debugger;
    sorted.sort((a, b) => {
      return a.order - b.order;
    });

    let toArrange = [];
    let count = 0;
    for (let x = 0; x < sorted.length; x++) {
      const prop = sorted[x].prop;
      if (typeof a[prop] !== "string") {
        if (a[prop]) {
          const meta = Tracking.getMeta(prop, this.stroke.type, this.fase.label);
          //console.log(meta);
          const line = this.createLine(meta, a[prop], fstart, fend, count, propNum);
          count++;

          // Crea la label della linea
          const text = this.scene.add.text(0, 0, meta.name, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_1) });
          text.setOrigin(0, 0);
          text.y = posy;
          this.add(text);
          toArrange.push({ line: line, text: text });

          line.y = posy + 8;
          posy += 32;
        }
      }
    }

    /*for (let prop in a) {
      if (typeof a[prop] !== "string") {
        if (a[prop]) {
          const meta = Tracking.getMeta(prop, this.stroke.type, this.fase.label);
          //console.log(meta);
          const line = this.createLine(meta, a[prop], fstart, fend, count, propNum);
          count++;

          // Crea la label della linea
          const text = this.scene.add.text(0, 0, meta.name, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_1) });
          text.setOrigin(0, 0);
          text.y = posy;
          this.add(text);
          toArrange.push({ line: line, text: text });

          line.y = posy + 8;
          posy += 32;
        }
      }
    }*/

    // Prende il testo più lungo
    let maxw = 0;
    toArrange.forEach((el) => {
      if (el.text.width > maxw) {
        maxw = el.text.width;
      }
    });
    toArrange.forEach((el) => {
      el.line.x = maxw + 32;
    });

    // Crea il background
    let text;
    if (toArrange.length > 0) {
      this.width = toArrange[0].line.x + toArrange[0].line.width + ZoomPanel.PADDING;
      this.height = posy + ZoomPanel.PADDING;
    } else {
      // Crea un testo di no data
      text = this.scene.add.text(0, 0, "-", { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_1) });
      text.setOrigin(0, 0);
      this.add(text);
      this.width = text.width + ZoomPanel.PADDING;
      this.height = text.height + ZoomPanel.PADDING + 40;
      text.x = ZoomPanel.PADDING / 2;
      text.y = ZoomPanel.PADDING / 2 + 40;
    }

    this.createBackground();

    // Porta tutot il resto su e li sposta di 16
    toArrange.forEach((el) => {
      this.bringToTop(el.line);
      this.bringToTop(el.text);
      el.line.y += ZoomPanel.PADDING / 2;
      el.text.y += ZoomPanel.PADDING / 2;
      el.line.x += ZoomPanel.PADDING / 2;
      el.text.x += ZoomPanel.PADDING / 2;
    });
    if (toArrange.length > 0) {
      this.bringToTop(toArrange[0].line);
    }

    // Quando ha l'altezza totale del blocco risetta l'altezza di tutti i vline
    this.vlines.forEach((el) => {
      el.height = toArrange[toArrange.length - 1].line.y - toArrange[0].line.y + this.currentRadius * 2 + this.currentRadius * 2;
      el.y = el.y - this.currentRadius;
    });

    this.bringToTop(this.title);
    if (text) {
      this.bringToTop(text);
    }
    this.frame_start = fstart;
    this.frame_end = fend;

    let rectClip = this.scene.add.rectangle(0, 0, this.width, this.title.y + this.title.displayHeight, ProgressBar.COLOR_FRONT);
    rectClip.setOrigin(0, 0);
    rectClip.alpha = 0.000001;
    this.add(rectClip);

    if (rectClip) {
      rectClip.setInteractive({ useHandCursor: true });
      rectClip.on("pointerup", this.overAll.bind(this));
    }
  }

  overAll() {
    this.setDepth(MainScene.ZINDEX);
    MainScene.ZINDEX++;
  }

  createLine(meta, datas, fstart, fend, count, propNum) {
    //console.log(datas);
    //console.log(count, propNum);

    const line = this.scene.add.container(0, 0);
    //const text = this.scene.add.text(0, 0, meta.label + ": " + value, { color: "#ffffff", fontSize: 12 });
    //this.add(text);
    // disegna un pallino da fstart a fend
    let x = 0;
    //let y = 0;

    const dif = fend - fstart;
    let ingombro = dif * this.restrictedRadius * 2;
    //console.log(ingombro);
    const maxWidth = (Tracking.WIDTH / 4) * 3;
    while (ingombro > maxWidth) {
      this.restrictedRadius--;
      ingombro = dif * this.restrictedRadius * 2;
    }
    //console.log(ingombro);

    //console.log(fstart, fend);
    const errors = datas.signed_errors;
    const values = datas.values;
    this.frame_start = fstart;

    for (let i = fstart; i < fend; i++) {
      let color = 0x999999;
      if (i >= datas.frame_start && i < datas.frame_start + errors.length) {
        if (errors[i - fstart - (datas.frame_start - fstart)] !== 0) {
          //color = 0xff2400;
          color = Tracking.REDDONE;
        } else {
          color = 0x00ff00;
        }
      }

      const rect = this.scene.add.rectangle(x, 2, this.restrictedRadius * 2, this.currentRadius * 2, color);
      rect.setOrigin(0, 0);
      x += this.restrictedRadius * 2;
      rect.setInteractive({ hitArea: new Phaser.Geom.Rectangle(0, 0, this.restrictedRadius * 2, this.currentRadius * 2), useHandCursor: true });
      rect.on("pointerup", () => {
        const time = i / MainScene.FPS;
        this.ct.ct.gotoTime(time);
        this.showVline(i - fstart);

        //console.log("over");
      });

      /*const circle = this.scene.add.circle(x, 0, this.currentRadius, color);
      circle.setOrigin(0, 0);
      x += this.currentRadius * 2;
      circle.setInteractive({ hitArea: new Phaser.Geom.Circle(0, 0, this.currentRadius * 2), useHandCursor: true });
      circle.on("pointerup", () => {
        const time = i / MainScene.FPS;
        this.ct.ct.gotoTime(time);

        this.showVline(i - fstart);

        //console.log("over");
      });
      line.add(circle);*/
      line.add(rect);
      line.width = x;

      // Disegna una linea verticale da fstart a fend solo se è il primo set di pallini
      if (count === 0) {
        //const vline = this.scene.add.rectangle(0, 0, 2, this.restrictedRadius * 2, ProgressBar.COLOR_BACK);
        const vline = this.scene.add.rectangle(0, 0, 2, 4, ProgressBar.COLOR_BACK);
        vline.setOrigin(0, 0);
        //line.addAt(vline, 0);
        line.add(vline);
        //vline.x = circle.x;
        vline.x = rect.x + this.restrictedRadius - 2;
        vline.y = 0;
        //        vline.height = propNum * this.currentRadius * 2 + 8 * propNum;
        //vline.width = this.restrictedRadius * 2;
        vline.height = propNum * this.currentRadius * 2 + 8 * propNum;
        vline.width = 4;
        //vline.alpha = 0.5;
        if (i - fstart > 0) {
          vline.visible = false;
        }
        this.vlines.push(vline);
      }
    }

    this.add(line);

    //console.log(value);
    return line;
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }

  createBackground() {
    const graphics = this.scene.add.graphics();
    graphics.fillGradientStyle(0x152ba0, 0x152ba0, 0x152ba0, 0x152ba0, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL);
    graphics.fillRect(0, 0, this.width, this.height);
    this.add(graphics);
  }

  showVline(index) {
    this.vlines.forEach((el) => {
      el.visible = false;
    });
    const el = this.vlines[index];
    if (el) {
      el.visible = true;
    }
  }

  setBar(frame) {
    frame = Math.round(frame);

    if (this.vlines.length === 0) {
      return;
    }
    const index = frame - this.frame_start;
    this.showVline(index);
  }
}
